import { Component, ViewEncapsulation, Inject, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { PFObject } from 'app/components/data/core/models/base/object';
import { Dispatcher } from 'app/components/data/core/models/persons/dispatcher';

import { LocaleService } from 'app/components/locale/locale.service';
import { create_dispatcher } from '../../locale/locale';

import { DataLoader } from 'app/components/data/data-loader';
import { CloudExecutor } from 'app/components/data/cloud-executors/cloud-executor';

import * as FormHelper from 'app/components/form-helper/form-helper';

@Component({
    selector   : 'dispatcher-dialog',
    templateUrl: './dispatcher-dialog.component.html',
    styleUrls  : ['./dispatcher-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class DispatcherDialog {
  compareFunction = PFObject.compareFn;

  public form: UntypedFormGroup;
  private object: Dispatcher;

  public title: string;
  public buttonName: string;

  public dataLoader: DataLoader;
  public dataSaver = new CloudExecutor;

  constructor (
    public dialogRef: MatDialogRef<DispatcherDialog>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _formBuilder: UntypedFormBuilder,
    private localeService: LocaleService
  ) {
    this.dataLoader = new DataLoader('Carrier');
    this.localeService.loadLocale(create_dispatcher);
    this.object = this._data.object;

    if (this._data.action === 'create') {
        this.title = 'DIALOG.DISPATCHER.TITLE.CREATE';
        this.buttonName = 'DIALOG.DISPATCHER.CONFIRMBUTTON.CREATE';
    } else if (this._data.action === 'edit') {
        this.title = 'DIALOG.DISPATCHER.TITLE.EDIT';
        this.buttonName = 'DIALOG.DISPATCHER.CONFIRMBUTTON.SAVE';
    }

    if (this.object == null) {
      this.object = new Dispatcher();
    }
    this.form = this.createContactForm();
    this.loadCarriers();
  }

  loadCarriers() {
    this.dataLoader.loadAll();
  }

  createContactForm(): UntypedFormGroup {
    let formGroup = {
      name: this.object.getName(),
      carrier: this.object.getCarrier(),
    };
    return this._formBuilder.group(formGroup);
  }

  checkAndSave() {
    if (this.checkForm()) {
      this.object.setName(this.form.get('name').value);
      this.object.setCarrier(this.form.get('carrier').value);

      this.dataSaver.saveObject(this.object).then(obj => {
        this.dialogRef.close(obj);
      });
    }
  }

  checkForm(): boolean {
    return FormHelper.checkForm(this.form);
  }
}
